import auroraColorPalette from '../colors';

const expantionPanel = {
  root: {
    '&:first-child': {
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
    },
    '&:last-child': {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
    '&$expanded': {
      borderRadius: 8,
      boxShadow: `0px 0px 0px 1px ${auroraColorPalette.primary.main}`,
      '& + div': {
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      },
    },
  },
};

export default expantionPanel;
